<template>
  <div>
    <!-- <div class="slide-show-content">
      <div><img class="slide-img" src="../../assets/img/banner.png" /></div>
      <div class="content-article">
        <div class="title fs-xx">浙大城市学院第二十届运动会落幕</div>
        <div class="describe">又是一年秋意浓,正好的天气，遇到正青春的你。</div>
      </div>
    </div> -->
    <swiper ref="mySwiper" :options="swiperOptions" v-if="swiperData.length">
      <swiper-slide v-for="item in swiperData" :key="item.id">
        <div class="slide-show-content">
          <div>
            <img class="slide-img" :src="item.rotatePictures" />
          </div>
          <div class="content-article">
            <div class="title fs-xx overflow">{{ item.title }}</div>
            <div class="describe overflow">
              {{ item.subtitle }}
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import navigationData from '../../assets/js/navData'
let vm = null
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  props: ['swiperData'],
  data() {
    return {
      swiperOptions: {
        loop: true,
        // preventClicks : true,
        // preventClicksPropagation : true,
        // mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true,
          dynamicBullets: false,
        },
        speed: 2000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        effect: 'slide',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          click: function () {
            vm.swiperClick(this)
          },
        },
      },
      navData: [],
      currHref: '',
      currKeep: 0,
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    },
  },
  created() {
    vm = this
  },
  mounted() {
    this.navData = navigationData
    // this.swiper.slideTo(0, 1000, true)
  },
  methods: {
    swiperClick(vm) {
      let index = vm.realIndex
      for (let i = 0; i < this.navData.length; i++) {
        if (this.swiperData[index].fatherCategory.name == this.navData[i].name)
          this.currHref = this.navData[i].href
        for (let j = 0; j < this.navData[i].child.length; j++) {
          if (
            this.swiperData[index].category.name ==
            this.navData[i].child[j].title
          )
            this.currKeep = j
        }
      }
      this.$router.push({
        path: '/article',
        query: {
          one: this.swiperData[index].fatherCategory.name,
          two: this.swiperData[index].category.name,
          three: '',
          path: this.currHref,
          keepalive: this.currKeep,
          //   keepchild: this.listChildIndex,
          articleId: this.swiperData[index].uuid,
          newbread: 'yes',
        },
      })
    },
    mySwiper() {},
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/main.scss';
.slide-show-content {
  width: 100%;
  min-width: 1100px;
  height: 20vw;
  min-height: 220px;
  position: relative;
  cursor: pointer;
}
.content-article {
  position: absolute;
  width: 580px;
  height: 60px;
  left: 192px;
  //   top: 66%;
  bottom: 15%;
  background: rgba(24, 24, 24, 0.5);
  color: $white;
  line-height: 30px;
}
.content-article {
  padding: 10px;
}
.slide-img {
  width: 100%;
  min-width: 1100px;
  min-height: 220px;
  height: 20vw;
}
</style>
<style lang="scss">
.swiper-container {
  .swiper-pagination {
    .swiper-pagination-bullet {
      width: 40px;
      height: 8px;
      border-radius: 0px;
      background: #ffffff;
      opacity: 0.6;
    }
    .swiper-pagination-bullet-active {
      width: 80px;
    }
  }
}
.describe {
  width: 100%;
}
</style>
